import React from "react";
import { useState ,useEffect} from "react";
import joi from "joi";
import axios from "axios";
import swal from "sweetalert";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import valid from "../utill/validation";
import auth from '../httpServices/authService';
import api from "../config.json";
import { Input } from "antd";

function DropDownInputCompForArray({title,Name,data,returnValue}) {
    const [inputdata, setinputdata] = useState({});
   
  console.log(title,data,Name,inputdata,"sdiuvnsduv")
    const handleOnChange = (e) => {
        const data = { ...inputdata };
        data[e.currentTarget.name] = e.target.value;
        returnValue(data)
        setinputdata(data);
      };
  return (
    <div className="col-sm-4 ">
    <div className="form-group text-center">
      <label>{title}</label>

      <select
        className="custom-select form-control"
        name={Name}
        onChange={handleOnChange}
        defaultValue={inputdata.Name}
      >
        <option>{`Select ${Name}`}</option>
        {data?.map(one => {
            return <option>{one}</option>
          })}
      </select>
    </div>
  </div> 
  )
}
function DropDownInputCompForObject({title,Name,data,option,returnValue,version,other,isMulti}) {
    const [inputdata, setinputdata] = useState({});
    const[arr,setArr]=useState([])
    console.log(data,"Promise return ")
    useEffect(()=>{
      if(data){
        data().then((res)=>{
          console.log(res,"vfdvnbdfkjbfgkn")
          setArr(res)
        })
        .catch((err)=>{})
      }
     
    },[])
   
    const [assetdata, setassetdata] = useState([]);
    const handleOnChange = (e) => {
      console.log(title,Name,inputdata,"sdiusdfgsfsdvnsduv")
        const data = { ...inputdata };
        data[e.currentTarget.name] = e.target.value;
        returnValue(data)
        setinputdata(data);
      };
  return (<>
    
    {/* {version && version.length >0 && version ==='v1' ? */}
    <div className="col-sm-4 ">
    <div className="form-group text-center">
      <label>{title}</label>

      <select
        className="custom-select form-control"
        name={Name}
        onChange={handleOnChange}
        defaultValue={inputdata.Name}
        // multiple={isMulti}
      >
        <option>{`Select ${Name}` || ''}</option>
        {arr?.map(one => {
            return <option value={other?one._id:one.option}>{one[`${option}`]}</option>
          })}
      </select>
    </div>
  </div>
  {/* : <div className="w-100 ">
            <div className="d-flex justify-content-between d-flex justify-content-between form-group text-center mt-1">
          <label> {title} </label>
          <select
           style={{width:'60%'}}
            className="custom-select"
            name={Name}
            onChange={handleOnChange}
            defaultValue={inputdata.Name}
          >
             <option>{`Select ${Name}`}</option>
        {data?.map(one => {
            return <option>{one[`${option}`]}</option>
          })}
      </select>
        </div>
          </div>} */}
  </>)
}


function DropDownInputCompForObject1({title,Name,data,option,returnValue,version}) {
  const [inputdata, setinputdata] = useState({});
  const[arr,setArr]=useState([])
  console.log(data,"Promise return ")
  // useEffect(()=>{
  //   if(data){
  //     data().then((res)=>{
  //       console.log(res,"vfdvnbdfkjbfgkn")
  //       setArr(res)
  //     })
  //     .catch((err)=>{})
  //   }
   
  // },[])
 
console.log(title,data,Name,inputdata,"wseff")
  const [assetdata, setassetdata] = useState([]);
  const handleOnChange = (e) => {
      const data = { ...inputdata };
      data[e.currentTarget.name] = e.target.value;
      returnValue(data)
      setinputdata(data);
    };
return (<>
  
  {/* {version && version.length >0 && version ==='v1' ? */}
  <div className="col-sm-4 ">
  <div className="form-group text-center">
    <label>{title}</label>

    <select
      className="custom-select form-control"
      name={Name}
      onChange={handleOnChange}
      defaultValue={inputdata.Name}
    >
      <option>{`Select ${Name}` || ''}</option>
      {data?.map(one => {
          return <option>{one[`${option}`]}</option>
        })}
    </select>
  </div>
</div>
{/* : <div className="w-100 ">
          <div className="d-flex justify-content-between d-flex justify-content-between form-group text-center mt-1">
        <label> {title} </label>
        <select
         style={{width:'60%'}}
          className="custom-select"
          name={Name}
          onChange={handleOnChange}
          defaultValue={inputdata.Name}
        >
           <option>{`Select ${Name}`}</option>
      {data?.map(one => {
          return <option>{one[`${option}`]}</option>
        })}
    </select>
      </div>
        </div>} */}
</>)
}

function TextInputComp({title,Name,data,returnValue,type}) {
    const [inputdata, setinputdata] = useState({});
   
  
    const handleOnChange = (e) => {
        const data = { ...inputdata };
        data[e.currentTarget.name] = e.target.value;
        returnValue(data,type,Name)
        setinputdata(data);
      };
    return (
        <div className="col-sm-8 ">
          <div className="form-group text-center">
            <label>{title}</label>
            <textarea
              rows="3" cols="70"
              type={type}
              className="form-control"
              placeholder={`Enter ${Name}`}
              name={Name}
              onChange={handleOnChange}
              defaultValue={inputdata.Name}
            />
          </div>
        </div>
    )
  }
  function TextInputFieldComp({ title, Name, data, returnValue, type, clearInput }) {
    const [inputdata, setinputdata] = useState({});

    // useEffect to clear inputdata when clearInput changes
    useEffect(() => {
        if (clearInput) {
            setinputdata({});
        }
    }, [clearInput]);

    const handleOnChange = (e) => {
        const newData = { ...inputdata };
        newData[e.currentTarget.name] = e.target.value;
        returnValue(newData, type, Name);
        setinputdata(newData);
    };

    return (
        <div className="col-sm-4  ">
          <div className="form-group text-center">
            <label>{title}</label>
            <input
              type={type}
              className="form-control"
              placeholder={`Enter ${Name}`}
              name={Name}
              onChange={handleOnChange}
              value={inputdata[Name] || ''} 
            />
          </div>
        </div>
    )
  }


  const SubmitData = async (datafromoutercomponent, route, schema, SuccesMessage, ErrorMessage) => {
    try {
        const data = { ...datafromoutercomponent };
        const errors = valid.validate(data, schema);
        let user = auth.getCurrentUser();
        console.log(errors);
        // seterrors({ errors: errors || {} });
        if (errors) {
            return errors;
        };
        console.log(user._id, data, "idhbi");
        const result = await axios.post(`${api.api}${route}`, data
        // { UserId: user._id, data: data }
        );
        if (result.status === 200) {
            toast.success(`${SuccesMessage}`, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                    backgroundColor: 'green', // Change this to the desired background color
                    color: 'white',           // Change this to the desired text color
                },
            });
            return 'successful';
        } else {
            swal(`${result.data.message}`);
        }
    } catch (err) {
        if (err.message === 'Request failed with status code 500') {
            toast.success(`${ErrorMessage}`, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                    backgroundColor: 'red', // Change this to the desired background color
                    color: 'white',           // Change this to the desired text color
                },
            });
        } else {
            //   setquery({ querySuccess: false });
        }
        // swal(`${err}`);
    }
};


export  {DropDownInputCompForArray,TextInputComp,DropDownInputCompForObject,SubmitData,TextInputFieldComp,DropDownInputCompForObject1}